/**
 * @generated SignedSource<<bc6ee3e54554d706cfffa14a0a1a0d90>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphQLJobRunStatus = "COMPLETED" | "ERRORED" | "IN_PROGRESS" | "PENDING" | "STOPPED" | "%future added value";
export type RerunJobInput = {
  jobRunId: any;
};
export type DagvestigationJobDetailsRerunMutation$variables = {
  input: RerunJobInput;
};
export type DagvestigationJobDetailsRerunMutation$data = {
  readonly rerunJob: {
    readonly jobRun: {
      readonly id: any;
      readonly status: GraphQLJobRunStatus;
    };
    readonly success: boolean;
  };
};
export type DagvestigationJobDetailsRerunMutation = {
  response: DagvestigationJobDetailsRerunMutation$data;
  variables: DagvestigationJobDetailsRerunMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RerunJobPayload",
    "kind": "LinkedField",
    "name": "rerunJob",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLJobRun",
        "kind": "LinkedField",
        "name": "jobRun",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DagvestigationJobDetailsRerunMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DagvestigationJobDetailsRerunMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "94e46ecad70b3cfec5bcf233a8056cac",
    "id": null,
    "metadata": {},
    "name": "DagvestigationJobDetailsRerunMutation",
    "operationKind": "mutation",
    "text": "mutation DagvestigationJobDetailsRerunMutation(\n  $input: RerunJobInput!\n) {\n  rerunJob(input: $input) {\n    success\n    jobRun {\n      id\n      status\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "eddcfe4d66cf908b178c374531b1f94a";

export default node;
